import {Component} from "@angular/core";

@Component({
    selector: 'report-standard',
    templateUrl: './report-standard.component.html',
    styleUrls: ['./report-standard.component.scss'],
    standalone: false
})
export class ReportStandardComponent {
}
